import { render } from "./LiveBadge.vue?vue&type=template&id=5fe325b2"
import script from "./LiveBadge.vue?vue&type=script&lang=js"
export * from "./LiveBadge.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__